import dayjs, { Dayjs } from "dayjs";

export function dayjsFromGermanDate(beginnStr: unknown): Dayjs | null {
  if (typeof beginnStr === "string") {
    const [beginnDay, beginnMonth, beginnYear] = beginnStr.split('.');
    return dayjs(new Date(`${beginnYear}-${beginnMonth}-${beginnDay}`));
  }

  return null;
}